module.exports = __webpack_public_path__ + "img/cnet.7bc15a0.png";